import styles from './StepHeader.module.css';

interface StepHeaderProps {
  step: number;
  label: string;
}

export default function StepHeader({ step, label }: StepHeaderProps) {
  const stepLabel = `STEP ${String(step).padStart(2, '0')}`;
  return (
    <div className={`line-row ${styles.root}`}>
      <span>{stepLabel}</span>
      <span className="line" />
      <span>{label}</span>
    </div>
  );
}
